
<div class="d-flex align-center" style="position: relative">
  <img
    :src="iconSrc"
    :style="{width: iconWidth, height: iconHeight}"
  >

  <!-- 즐겨찾기 표시 -->
  <img v-if="showFavorite && favorite"
    src="/assets/favorite-small.svg"
    style="position: absolute; right: 1px; bottom: 1px"
    :style="{width: `calc(${iconWidth}/2)`, height: `calc(${iconHeight}/2)`}"
  >
</div>
